import {createEntityAdapter, EntityState} from '@ngrx/entity';
import {Author} from '../models/author.model';
import {createReducer, on} from '@ngrx/store';
import {AuthorActions} from './action-types';


export interface AuthorsState extends EntityState<Author> {
  authorsLoaded:boolean;
}



const adapter = createEntityAdapter<Author>();

const initialAuthorState = adapter.getInitialState({
  authorsLoaded: false
});




export const authorsReducer = createReducer(

  initialAuthorState,

  on(AuthorActions.upsertAuthor, (state, action) => adapter.upsertOne(action.author, state) ) ,

  on(AuthorActions.authorsLoaded, (state, action) =>
    adapter.setAll(
      action.authors.filter(author =>
        author.id !== undefined &&
        author.id !== null &&
        author.id !== 'undefined'
      ),
      {
        ...state,
        authorsLoaded: true
      }
    )
  ))

;



export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();


